import React, { useState } from "react";
import "./Login.css";
import logo from "../../assets/expert_logo.webp";
import { loginWithApi } from "../../services/auth";


export default function Login() {
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [lang, setLang] = useState("English");
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");


  async function onLogin() {
    const mob = mobile.trim();
    const pwd = password;

    if (!mob || !pwd) {
      setErrorMsg("Please enter mobile number and password.");
      return;
    }

    setLoading(true);
    setErrorMsg("");

    try {
      await loginWithApi(mob, pwd);

      // For now: simple redirect (we will create dashboard next)
      window.location.assign("/dashboard");
    } catch (e) {
      const code = e?.message || "";

      if (code === "INVALID_CREDENTIALS") {
        setErrorMsg("Invalid mobile number or password.");
      } else if (code === "SERVER_PARSE_ERROR") {
        setErrorMsg("Server response error. Please try again.");
      } else {
        setErrorMsg("Network error. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  }


  return (
    <div className="loginPage">
      {/* Top bar */}
      <div className="topBar">
        <div className="brandLeft">
          <img className="brandLogo" src={logo} alt="Expert Dairy" />
        </div>

        <div className="langRight">
          <select
            className="langSelect"
            value={lang}
            onChange={(e) => setLang(e.target.value)}
          >
            <option>English</option>
            <option>Marathi</option>
            <option>Hindi</option>
          </select>
        </div>
      </div>

      {/* Center */}
      <div className="centerWrap">
        <h1 className="pageTitle">Login</h1>

        <div className="card">
          {/* Left - form */}
          <div className="cardLeft">
            <div className="cardSubTitle">Sign In to your account</div>
            {errorMsg ? <div className="errorText">{errorMsg}</div> : null}


            <div className="inputRow">
              <div className="iconBox">👤</div>
              <input
                className="textInput"
                placeholder="Mobile Number"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
              />
            </div>

            <div className="inputRow">
              <div className="iconBox">🔒</div>
              <input
                className="textInput"
                placeholder="Password"
                type={showPass ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                className="eyeBtn"
                onClick={() => setShowPass((v) => !v)}
                aria-label="Toggle password"
              >
                {showPass ? "🙈" : "👁️"}
              </button>
            </div>

            <div className="bottomRow">


              <button type="button" className="linkBtn" onClick={() => window.location.assign("/forgot")}>
                Forgot Password?
              </button>


              <button className="loginBtn" type="button" onClick={onLogin} disabled={loading}>
                {loading ? "Logging in..." : "Login"}
              </button>

            </div>
          </div>

          {/* Divider */}
          <div className="dividerCol">
            <div className="dividerLine" />
            <div className="orText">OR</div>
            <div className="dividerLine" />
          </div>

          {/* Right - QR */}
          <div className="cardRight">
            <div className="cardSubTitle" style={{ textAlign: "center" }}>
              Scan QR
            </div>

            <div className="qrBox">
              {/* Placeholder QR */}
              <div className="qrPlaceholder">QR</div>
              <div className="qrRefresh">⟳</div>
            </div>
          </div>
        </div>

        <div className="registerWrap">
          <div className="registerText">Not Registered Yet?</div>
          <button
            className="registerBtn"
            type="button"
            onClick={() => window.location.assign("/register")}

          >
            Register Now
          </button>
           <div className="vertext">Ver_1.0.2</div>
        </div>
      </div>
    </div>
  );
}
